import { Button, Card, Form, Message, Switch } from '@alifd/next';
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';

import commonhelper from '@/lib/commonhelper';
import client from '@/lib/feathers';

import styles from './MobileSystemSetting.module.scss';

const { Item } = Form;

const SystemSetting = (props) => {
  const users = client.service('users');
  const [currentAuthId, setCurrentAuthId] = useState('');
  const [currentUser, setCurrentUser] = useState([]);
  const [emitAllowStatus, setEmitAllowStatus] = useState(true);
  const [allow, setAllow] = useState([]);
  const [outObjData, setOutObjData] = useState({});
  // console.log("emitAllowStatus", emitAllowStatus)

  const menus = [
    //設定推播
    '公告事項',
    '行事曆',
    '郵件包裹',
    '寄物管理',
    '公設預約',
    '訪客管理',
    '訪客門禁',
    '投票活動',
    '報修服務',
    '瓦斯抄表',
    '社區管理',
    '意見反應',
    '智慧信箱',
    '家庭保全',
  ];

  useEffect(() => {
    client.reAuthenticate().then((data) => {
      console.log('==relogin ok', data);
      setCurrentAuthId(data.user._id);
      setCurrentUser(data.user);
      setAllow(
        data.user.allow.map((x) => x.name).filter((x) => menus.includes(x))
      );
      if (Object.prototype.hasOwnProperty.call(data.user, 'banEmit')) {
        let obj = {};
        Object.keys(data.user.banEmit).forEach((e) => {
          obj[e] = true;
        });
        setOutObjData({ ...obj });
      }
      if (
        !Object.prototype.hasOwnProperty.call(data.user, 'emitAllow') ||
        (Object.prototype.hasOwnProperty.call(data.user, 'emitAllow') &&
          data.user.emitAllow === true)
      ) {
        //判斷用戶沒有關閉推播
        setEmitAllowStatus(true);
      } else {
        setEmitAllowStatus(false);
      }
    });
  }, []);

  async function funFind() {
    const result = await users.find({
      query: {
        _id: currentAuthId,
      },
    });
    return result && result.data ? result.data : [];
  }
  async function funCreate(obj) {
    return await users.create(obj);
  }
  async function funUpdate(id, obj) {
    return await users.patch(id, obj);
  }
  async function funRemove(id) {
    return await users.remove(id);
  }

  function serverDataUpdate() {
    users
      .find({
        query: {
          _id: currentAuthId,
        },
      })
      .then((res) => {
        console.log('=====res', res);
        if (res.total == 0) return;
        console.log(
          '=====res1',
          Object.prototype.hasOwnProperty.call(res.data[0], 'banEmit')
        );
        if (Object.prototype.hasOwnProperty.call(res.data[0], 'banEmit')) {
          let obj = {};
          Object.keys(res.data[0].banEmit).forEach((e) => {
            obj[e] = true;
          });
          setOutObjData({ ...obj });
        }
      });
  }
  useEffect(() => {
    serverDataUpdate();
  }, [currentAuthId]);

  return (
    <div className={styles.mobileSetting}>
      <div className={styles.mobileSettingBackground} />
      <div className={styles.emitSettingBox}>
        <div className={styles.emitSettingFlex}>
          <div className={styles.emitSetting}>一鍵推播</div>
          <Switch
            checked={emitAllowStatus === true ? true : false}
            className={styles.switchWidth}
            checkedChildren="開"
            unCheckedChildren="關"
            onChange={(checked) => {
              const newBanEmit = {};
              if (!checked) {
                allow.forEach((e) => (newBanEmit[e] = true));
              }

              const newUser = {
                ...currentUser,
                emitAllow: checked,
                banEmit: newBanEmit,
              };

              setEmitAllowStatus(checked);
              setOutObjData({ ...newBanEmit });

              funUpdate(newUser._id, newUser)
                .then((res) => {
                  console.log('==users emitAllow update success:', res);
                  serverDataUpdate();
                  Message.success('更新成功');
                })
                .catch((error) => {
                  console.log('==users emitAllow update fail:', error);
                  Message.error(`${error}`);
                });
            }}
          />
        </div>
        {allow.map((list, index) => {
          return (
            <div key={index} className={styles.emitSettingFlex}>
              <div className={styles.emitSetting} key={index}>
                {list}
              </div>
              <Switch
                checked={
                  !Object.prototype.hasOwnProperty.call(outObjData, list)
                }
                className={styles.switchWidth}
                checkedChildren="開"
                unCheckedChildren="關"
                onChange={(checked) => {
                  // console.log(list)
                  // console.log(checked)

                  if (checked) delete outObjData[list];
                  else {
                    outObjData[list] = true;
                  }

                  let cloneUserObj = JSON.parse(JSON.stringify(currentUser));
                  delete cloneUserObj.banEmit;
                  cloneUserObj.banEmit = { ...outObjData };

                  if (Object.keys(outObjData).length >= allow.length) {
                    cloneUserObj.emitAllow = false;
                    setEmitAllowStatus(false);
                  } else {
                    cloneUserObj.emitAllow = true;
                    setEmitAllowStatus(true);
                  }

                  funUpdate(currentAuthId, cloneUserObj)
                    .then((res) => {
                      console.log('==users emitAllow update success:', res);
                      serverDataUpdate();
                      Message.success('更新成功');
                    })
                    .catch((error) => {
                      console.log('==users emitAllow update fail:', error);
                      Message.error(`${error}`);
                    });

                  setOutObjData({ ...outObjData });
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SystemSetting;
